module.exports = __webpack_public_path__ + "img/icon-allread-icon-mark as read.fd6ce848.svg";